// Профиль, человек, важные даты, поддержка, документы.

import { useEffect, useState } from 'react';
import { api, type Taste } from '../lib/api.ts';
import { useApp, emptyTaste } from '../lib/store.tsx';
import { closeApp, haptic, inTelegram } from '../lib/tg.ts';
import { onSite } from '../lib/web.ts';
import { track } from '../lib/events.ts';
import { dateRepeat, tasteSummary, dm, dayMonth, rub, tasteText, FLOWER_RU, GAMMA_RU, FORM_RU, OCCASION_RU } from '../lib/format.ts';
import { ErrorNote, Icon, PhotoPicker, Spinner, Switch, TitleTop, toast } from '../ui/kit.tsx';
import { ConsentSheet } from './start.tsx';

export function Profile() {
  const { go, me, reloadMe, startFlow, home, catalog } = useApp();
  const [confirm, setConfirm] = useState(false);
  useEffect(() => {
    reloadMe();
  }, []);
  if (!me) return <main className="screen"><Spinner /></main>;
  const DONE = ['delivered', 'cancelled', 'unpaid'];
  const active = me.orders.filter((o) => !DONE.includes(o.status));
  const past = me.orders.filter((o) => DONE.includes(o.status));

  return (
    <main className="screen" style={{ gap: 20 }}>
      <TitleTop title={me.user.firstName ?? 'Профиль'} />
      {active.length > 0 && (
        <section className="stack">
          <span className="label">Текущие заказы</span>
          {active.map((o) => (
            <button key={o.publicId} type="button" className="tile" style={{ background: 'var(--butter)', borderColor: 'var(--butter-line)' }} onClick={() => go({ name: 'order', orderId: o.publicId })}>
              <span className="stack s6" style={{ gap: 2, flex: 1 }}>
                <span style={{ fontWeight: 600 }}>
                  {o.kind === 'surprise' ? 'Сюрприз' : o.kind === 'individual' ? 'Индивидуальный букет' : o.designName}, {o.size}
                  {o.recipientName ? ` · ${o.recipientName}` : ''}
                </span>
                <span className="tiny" style={{ color: 'var(--ink-2)' }}>
                  {o.date ? `${dayMonth(o.date)} · ` : ''}
                  {o.statusText}
                </span>
              </span>
              <Icon name="next" size={18} />
            </button>
          ))}
        </section>
      )}

      {me.promos.length > 0 && (
        <section className="stack">
          <span className="label">Мои акции</span>
          <div className="list" data-noev>
            {me.promos.map((p) => (
              <button key={p.id} type="button" onClick={() => {
                  if (p.kind === 'individual') return go({ name: 'individual' });
                  startFlow('self');
                  go({ name: 'when' });
                }}>
                <span style={{ width: 40, height: 40, borderRadius: 20, background: 'var(--butter)', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 'none' }}>
                  <Icon name="gift" size={18} />
                </span>
                <span className="stack s6" style={{ gap: 2, flex: 1 }}>
                  <span>{p.title}</span>
                  {p.until && <span className="tiny">Действует {p.until}</span>}
                </span>
                <Icon name="next" size={18} />
              </button>
            ))}
          </div>
        </section>
      )}

      <section className="stack">
        <span className="label">Люди и важные даты</span>
        <div className="list" data-noev>
          {me.people.map((p) => {
            const ds = me.dates.filter((d) => d.personId === p.id);
            return (
              <button key={p.id} type="button" onClick={() => go({ name: 'person', personId: p.id })}>
                <span style={{ width: 40, height: 40, borderRadius: 20, background: 'var(--pink)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600, flex: 'none' }}>{p.name[0]}</span>
                <span className="stack s6" style={{ gap: 2, flex: 1 }}>
                  <span>{p.name}</span>
                  <span className="tiny">{ds.length ? ds.map((d) => `${OCCASION_RU[d.occasion]} · ${dm(d.month, d.day)}${d.year ? ` ${d.year}` : ""}`).join(', ') : 'дат пока нет'}</span>
                </span>
                <Icon name="next" size={18} />
              </button>
            );
          })}
          {me.dates
            .filter((d) => d.personId === null)
            .map((d) => (
              <div key={d.id}>
                <span style={{ width: 40, height: 40, borderRadius: 20, background: 'var(--butter)', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 'none' }}>
                  <Icon name="calendar" size={18} />
                </span>
                <span className="stack s6" style={{ gap: 2, flex: 1 }}>
                  <span>Мой {OCCASION_RU[d.occasion]}</span>
                  <span className="tiny">{dateRepeat(d)} · напомним за {d.remindDays === 1 ? 'день' : d.remindDays === 7 ? 'неделю' : `${d.remindDays} дня`}</span>
                </span>
              </div>
            ))}
          <button type="button" onClick={() => go({ name: 'dates' })} style={{ fontWeight: 500 }}>
            <Icon name="plus" size={18} />
            Добавить дату
          </button>
        </div>
      </section>

      {past.length > 0 && (
        <section className="stack">
          <span className="label">Мои заказы</span>
          <div className="list" data-noev>
            {past.map((o) => (
              <div key={o.publicId}>
                <button type="button" onClick={() => go({ name: 'order', orderId: o.publicId })} className="stack s6" style={{ gap: 2, flex: 1, background: 'none', border: 'none', padding: 0, textAlign: 'left', color: 'inherit', font: 'inherit' }}>
                  <span>
                    {o.kind === 'surprise' ? 'Сюрприз' : o.kind === 'individual' ? 'Индивидуальный букет' : o.designName}, {o.size}
                    {o.recipientName ? ` · ${o.recipientName}` : ' · себе'}
                  </span>
                  <span className="tiny">
                    {dayMonth(o.date)} · {rub(o.total)}
                  </span>
                </button>
                <span className={`badge ${o.status === 'delivered' ? 'ok' : 'warn'}`}>{o.status === 'delivered' ? 'вручён' : o.status === 'unpaid' ? 'не оплачен' : 'отменён'}</span>
                {o.status === 'delivered' && <button
                  type="button"
                  className="link"
                  style={{ fontSize: 13, fontWeight: 600, minHeight: 44 }}
                  onClick={async () => {
                    // «Похожий»: сразу к трём букетам в том же размере и под уже известный вкус.
                    // Если вкус пустой, берём гамму и форму того букета. День и время выберем при оформлении.
                    const design = catalog.find((x) => x.id === o.designId);
                    const known = o.kind === 'gift' && o.personId ? (await api.person(o.personId).catch(() => null))?.taste ?? null : me.taste;
                    const empty = !known || ![...known.gammasLike, ...known.formsLike, ...known.flowersLike].length;
                    const taste = empty && design ? { ...(known ?? emptyTaste()), gammasLike: [design.gamma], formsLike: [design.form] } : known ?? emptyTaste();
                    const common = { size: o.size, taste, occasion: o.occasion, date: null, slotFrom: null };
                    if (o.kind === 'gift') startFlow('gift', { ...common, personId: o.personId, personName: o.recipientName });
                    else startFlow('self', common);
                    go({ name: 'result' });
                  }}
                >
                  Похожий
                </button>}
              </div>
            ))}
          </div>
        </section>
      )}

      <section className="stack">
        <span className="label">Мой вкус</span>
        <div className="card row">
          <span className="small" style={{ flex: 1, color: 'var(--ink-2)' }}>
            {me.taste ? tasteText(me.taste) || 'Знаем совсем немного' : 'Пока не знаем. Пройди свайпы, и подберём точнее'}
            {me.taste?.flowersDislike.length ? `. Не люблю: ${me.taste.flowersDislike.map((f) => FLOWER_RU[f] ?? f).join(', ')}` : ''}
          </span>
          <button
            type="button"
            className="link"
            style={{ fontSize: 14, fontWeight: 600, minHeight: 44 }}
            onClick={() => {
              startFlow('self', { taste: me.taste ?? emptyTaste() });
              go({ name: 'swipes' });
            }}
          >
            Обновить
          </button>
        </div>
      </section>

      <section className="list">
        <div style={{ justifyContent: 'space-between' }}>
          <span>Сообщать о заказах</span>
          <Switch label="Сообщать о заказах" on={me.user.notifyOrders} onChange={(v) => api.updateMe({ notifyOrders: v }).then(reloadMe)} />
        </div>
        <div style={{ justifyContent: 'space-between' }}>
          <span>Напоминания и подборки</span>
          <Switch label="Напоминания и подборки" on={me.user.consentAds} onChange={(v) => api.consent(v).then(reloadMe)} />
        </div>
        <button type="button" onClick={() => go({ name: 'docs' })}>
          <span style={{ flex: 1 }}>Документы и контакты</span>
          <Icon name="next" size={18} />
        </button>
        <button type="button" onClick={() => go({ name: 'support' })}>
          <span style={{ flex: 1 }}>Написать в поддержку</span>
          <Icon name="next" size={18} />
        </button>
      </section>

      {confirm ? (
        <div className="card stack">
          <span>Удалим твой вкус, людей и даты и отзовём согласия. Заказы остаются: их мы обязаны хранить по закону.</span>
          <div className="row">
            <button
              type="button"
              className="btn sm"
              style={{ flex: 1, background: 'var(--err-ink)', color: '#fff' }}
              onClick={async () => {
                await api.forget();
                await reloadMe();
                toast('Данные удалены');
                home();
              }}
            >
              Удалить
            </button>
            <button type="button" className="btn sm outline" style={{ flex: 1 }} onClick={() => setConfirm(false)}>
              Отмена
            </button>
          </div>
        </div>
      ) : (
        <button type="button" className="quiet" style={{ color: 'var(--err-ink)', fontSize: 14 }} onClick={() => setConfirm(true)}>
          Удалить мой вкус и отозвать согласие
        </button>
      )}
    </main>
  );
}

type Pref = 'like' | 'no' | null;
const TASTE_GROUPS = [
  { title: 'Цвета', like: 'gammasLike', no: 'gammasDislike', labels: GAMMA_RU },
  { title: 'Форма', like: 'formsLike', no: 'formsDislike', labels: FORM_RU },
  { title: 'Цветы', like: 'flowersLike', no: 'flowersDislike', labels: FLOWER_RU },
] as const;

/**
 * Вкус человека, который можно поправить прямо здесь: нажатие переключает пункт
 * «нравится» → «не надо» → «без разницы». Сохраняем одной кнопкой, она появляется только после изменений.
 */
function TasteEditor({ taste, onSave, onSwipes }: { taste: Taste; onSave: (t: Taste) => Promise<void>; onSwipes: () => void }) {
  const [t, setT] = useState<Taste>(taste);
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(false);
  useEffect(() => setT(taste), [taste]);
  const dirty = JSON.stringify(t) !== JSON.stringify(taste);
  const prefOf = (g: (typeof TASTE_GROUPS)[number], id: string): Pref => ((t[g.like] as string[]).includes(id) ? 'like' : (t[g.no] as string[]).includes(id) ? 'no' : null);
  const cycle = (g: (typeof TASTE_GROUPS)[number], id: string) => {
    const next: Pref = { like: 'no', no: null, null: 'like' }[String(prefOf(g, id)) as 'like' | 'no' | 'null'] as Pref;
    const like = (t[g.like] as string[]).filter((x) => x !== id);
    const no = (t[g.no] as string[]).filter((x) => x !== id);
    if (next === 'like') like.push(id);
    if (next === 'no') no.push(id);
    setT({ ...t, [g.like]: like, [g.no]: no } as Taste);
    setSaved(false);
    haptic.tap();
  };
  return (
    <div className="card stack">
      {TASTE_GROUPS.map((g) => (
        <div key={g.title} className="stack s6">
          <span className="label">{g.title}</span>
          <div className="wrap">
            {Object.entries(g.labels).map(([id, label]) => {
              const p = prefOf(g, id);
              return (
                <button
                  key={id}
                  type="button"
                  className="chip sm"
                  aria-pressed={p === 'like'}
                  aria-label={`${label}: ${p === 'like' ? 'нравится' : p === 'no' ? 'не надо' : 'без разницы'}`}
                  onClick={() => cycle(g, id)}
                  style={p === 'no' ? { background: 'var(--sand)', color: 'var(--muted)', textDecoration: 'line-through' } : undefined}
                >
                  {p === 'like' ? '✓ ' : p === 'no' ? '✕ ' : ''}
                  {label}
                </button>
              );
            })}
          </div>
        </div>
      ))}
      <span className="tiny">Нажми, чтобы поменять: ✓ нравится → ✕ не надо → без разницы</span>
      {dirty ? (
        <button
          type="button"
          className="btn sm"
          disabled={busy}
          onClick={async () => {
            setBusy(true);
            try {
              await onSave(t);
              track('taste_saved', { for_person: true, changes: (['gammasLike', 'gammasDislike', 'formsLike', 'formsDislike', 'flowersLike', 'flowersDislike'] as const).filter((k) => JSON.stringify(t[k]) !== JSON.stringify(taste[k])).length });
              haptic.ok();
              setSaved(true);
            } finally {
              setBusy(false);
            }
          }}
        >
          {busy ? 'Сохраняем…' : 'Сохранить'}
        </button>
      ) : saved ? (
        <div className="status">
          <Icon name="check" size={20} width={2.6} />
          Сохранили
        </div>
      ) : null}
      <button type="button" className="link" style={{ alignSelf: 'flex-start', fontSize: 14, minHeight: 36 }} onClick={onSwipes}>
        Или пройти свайпы заново
      </button>
    </div>
  );
}


export function Person({ personId, addTaste }: { personId: number; addTaste?: boolean }) {
  const { go, startFlow } = useApp();
  const [data, setData] = useState<Awaited<ReturnType<typeof api.person>> | null>(null);
  const [error, setError] = useState<string | null>(null);
  const load = () => api.person(personId).then(setData, (e) => setError(e.message));
  useEffect(() => {
    load();
  }, [personId]);
  if (!data) return <main className="screen">{error ? <ErrorNote error={error} /> : <Spinner />}</main>;
  const t = data.taste;

  return (
    <main className="screen">
      <TitleTop title={data.person.name} eyebrow={data.dates.map((d) => `${OCCASION_RU[d.occasion]} · ${dm(d.month, d.day)}`).join(', ') || undefined} />
      <span className="label">{addTaste ? 'Что любит, а что не надо' : 'Вкус'}</span>
      <TasteEditor
        taste={t}
        onSave={async (next) => {
          await api.saveTaste(personId, next);
          await load();
        }}
        onSwipes={() => {
          startFlow('gift', { personId, personName: data.person.name, relation: data.person.relation, taste: t });
          go({ name: 'swipes' });
        }}
      />
      {data.orders.length > 0 && (
        <div className="stack">
          <span className="label">Что уже дарили</span>
          <div className="list" data-noev>
            {data.orders.map((o) => (
              <div key={o.publicId}>
                <span className="stack s6" style={{ gap: 2, flex: 1 }}>
                  <span>
                    {o.designName ?? 'Сюрприз'}, {o.size}
                  </span>
                  <span className="tiny">{dayMonth(o.date)}</span>
                </span>
                {o.liked !== null && <span className={`badge ${o.liked ? 'ok' : 'warn'}`}>{o.liked ? 'в точку' : 'мимо'}</span>}
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="bottom">
        <button
          type="button"
          className="btn"
          onClick={() => {
            startFlow('gift', { personId, personName: data.person.name, relation: data.person.relation, taste: t });
            go({ name: 'giftOccasion' });
          }}
        >
          Подобрать букет
        </button>
        <button type="button" className="quiet" onClick={() => go({ name: 'dates' })}>
          Добавить дату
        </button>
      </div>
    </main>
  );
}

const WHO = [
  ['mom', 'Маме'],
  ['love', 'Любимым'],
  ['friend', 'Подруге или другу'],
  ['work', 'Коллеге'],
  ['me', 'Себе'],
] as const;
const OCC = [
  ['birthday', 'День рождения'],
  ['anniversary', 'Годовщина'],
  ['holiday', 'Праздник'],
  ['other', 'Другое'],
] as const;

/** «мама», «любимый человек», а своё имя как есть: «Аня». */
const DEFAULT_NAMES = ['Мама', 'Любимый человек', 'Друг', 'Коллега', 'Близкий человек'];
function whoName(name: string | null, inSentence = false) {
  const n = name ?? 'Близкий человек';
  return inSentence && DEFAULT_NAMES.includes(n) ? n.toLowerCase() : n;
}

export function DatesAdd() {
  const { me, reloadMe, go, back, startFlow } = useApp();
  const [who, setWho] = useState<string>('mom');
  const [name, setName] = useState('');
  const [occ, setOcc] = useState<string>('birthday');
  const [date, setDate] = useState('');
  const [remind, setRemind] = useState(3);
  // Повтор: ДР, годовщина и праздник обычно каждый год, «другое» чаще разовое. Пока клиент не выбрал сам, следуем за поводом.
  const [yearlyPick, setYearlyPick] = useState<boolean | null>(null);
  const yearly = yearlyPick ?? occ !== 'other';
  const [saved, setSaved] = useState(false);
  // Что показать после сохранения: первая ли это дата и знаем ли уже вкус того, для кого дата.
  const [after, setAfter] = useState<{ first: boolean; personId: number | null; name: string | null; taste: string } | null>(null);
  const [needConsent, setNeedConsent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const save = async () => {
    setError(null);
    if (!date) return setError('Выбери дату');
    if (!me?.user.consentPd) return setNeedConsent(true);
    try {
      const first = !me.dates.length && !me.people.length;
      const r = await api.addDate({ relation: who, personName: name.trim() || undefined, occasion: occ, date, remindDays: remind, yearly });
      track('date_saved', { occasion: occ, yearly, remind });
      haptic.ok();
      const m = await reloadMe();
      if (r.personId) {
        const pd = await api.person(r.personId).catch(() => null);
        setAfter({ first, personId: r.personId, name: pd?.person.name ?? null, taste: pd ? tasteSummary(pd.taste) : '' });
      } else setAfter({ first, personId: null, name: null, taste: tasteSummary(m?.taste ?? null) });
      setSaved(true);
    } catch (e: any) {
      setError(e.message);
    }
  };

  return (
    <main className="screen">
      <TitleTop title="Напомним о важном" />
      <p className="p">Заказывать сейчас не нужно. Добавь дату, и за несколько дней до неё пришлём в Telegram три идеи букета.</p>
      {!saved ? (
        <>
          <div className="stack">
            <span className="label">Для кого</span>
            <div className="wrap">
              {WHO.map(([id, label]) => (
                <button key={id} type="button" className="chip" aria-pressed={who === id} onClick={() => setWho(id)}>
                  {label}
                </button>
              ))}
            </div>
            {who !== 'me' && <input className="input" placeholder="Имя, если хочешь: «мама»" value={name} maxLength={60} onChange={(e) => setName(e.target.value)} aria-label="Имя, необязательно" />}
          </div>
          <div className="stack">
            <span className="label">Повод</span>
            <div className="wrap">
              {OCC.map(([id, label]) => (
                <button key={id} type="button" className="chip" aria-pressed={occ === id} onClick={() => setOcc(id)}>
                  {label}
                </button>
              ))}
            </div>
          </div>
          <div className="grid2">
            <label className="field">
              <span>Дата</span>
              {/* Родной календарь показывает дату в формате телефона (бывает 02/14/2027), поэтому сверху своя подпись: 14.02.2027 */}
              <span className="input" style={{ position: 'relative', display: 'flex', alignItems: 'center', padding: '0 12px', fontWeight: 400, fontSize: 16, color: date ? 'var(--ink)' : 'var(--muted)' }}>
                {date ? date.split('-').reverse().join('.') : 'дд.мм.гггг'}
                <input type="date" aria-label="Дата" value={date} onChange={(e) => setDate(e.target.value)} style={{ position: 'absolute', inset: 0, opacity: 0, width: '100%', height: '100%' }} />
              </span>
            </label>
            <label className="field">
              <span>Напомнить</span>
              <select className="input" value={remind} onChange={(e) => setRemind(Number(e.target.value))} style={{ padding: '0 12px' }}>
                <option value={1}>за день</option>
                <option value={3}>за 3 дня</option>
                <option value={7}>за неделю</option>
              </select>
            </label>
          </div>
          <div className="stack s6">
            <span className="label">Повторять</span>
            <div className="wrap">
              <button type="button" className="chip" aria-pressed={yearly} onClick={() => setYearlyPick(true)}>
                Каждый год
              </button>
              <button type="button" className="chip" aria-pressed={!yearly} onClick={() => setYearlyPick(false)}>
                Один раз
              </button>
            </div>
          </div>
          <ErrorNote error={error} />
          <button type="button" className="btn" onClick={save}>
            Сохранить дату
          </button>
          <p className="tiny" style={{ margin: 0 }}>
            Создадим профиль с этой датой без заказа и оплаты. Это напоминание о твоём событии, а не рассылка.
          </p>
        </>
      ) : (
        <div className="stack s14">
          <div className="status">
            <Icon name="check" size={20} width={2.6} />
            Сохранили. Напомним за {remind === 1 ? 'день' : remind === 7 ? 'неделю' : '3 дня'}
          </div>
          {after?.first && <span className="label">Профиль создан. Что ещё можно добавить</span>}
          {after?.taste && (
            <div className="card small" style={{ color: 'var(--ink-2)' }}>
              {after.personId ? `${whoName(after.name)} любит: ` : 'Твой вкус: '}
              {after.taste}
            </div>
          )}
          {after && (
            <button
              type="button"
              className="btn outline"
              onClick={() => {
                if (after.personId) return go({ name: 'person', personId: after.personId, addTaste: true });
                startFlow('self', { taste: me?.taste ?? emptyTaste() });
                go({ name: 'swipes' });
              }}
            >
              {after.personId
                ? `${after.taste ? 'Уточнить' : 'Рассказать'}, что любит ${whoName(after.name, true)}`
                : after.taste
                  ? 'Уточнить мой вкус'
                  : 'Рассказать о своём вкусе'}
            </button>
          )}
          <button type="button" className="btn light" onClick={() => (setSaved(false), setDate(''), setName(''), setAfter(null))}>
            <Icon name="plus" size={18} />
            Ещё одну дату
          </button>
          <button type="button" className="btn" onClick={() => go({ name: 'profile' })}>
            Открыть профиль
          </button>
          <button type="button" className="quiet" onClick={back}>
            Назад
          </button>
        </div>
      )}
      {needConsent && (
        <ConsentSheet
          onDone={async () => {
            await reloadMe();
            setNeedConsent(false);
            setTimeout(save, 0);
          }}
          onSkip={() => setNeedConsent(false)}
        />
      )}
    </main>
  );
}

const TOPICS = [
  ['order', 'Текущий заказ'],
  ['quality', 'Букет пришёл не таким'],
  ['pay', 'Оплата и чек'],
  ['change', 'Изменить время или адрес'],
  ['other', 'Другое'],
] as const;

export function Support({ orderId }: { orderId?: string }) {
  const { me, back } = useApp();
  const [topic, setTopic] = useState<string>(orderId ? 'order' : 'other');
  const [text, setText] = useState('');
  const [photo, setPhoto] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const order = orderId ?? me?.orders.find((o) => !['delivered', 'cancelled', 'unpaid'].includes(o.status))?.publicId;
  return (
    <main className="screen">
      <TitleTop title="Поддержка" />
      <div className="row" style={{ background: 'var(--butter)', borderRadius: 20, padding: '14px 16px' }}>
        <span style={{ width: 44, height: 44, borderRadius: 22, background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 'none' }}>
          <Icon name="mail" size={22} width={1.8} />
        </span>
        <span className="stack s6" style={{ gap: 2 }}>
          <span style={{ fontWeight: 600 }}>Отвечает живой человек</span>
          <span className="tiny" style={{ color: 'var(--ink-2)' }}>
            Ежедневно 8:00–22:00, обычно за 15 минут
          </span>
        </span>
      </div>
      <div className="stack s6">
        <span className="label">О чём вопрос?</span>
        <div className="list" data-noev>
          {TOPICS.map(([id, label]) => (
            <button key={id} type="button" aria-pressed={topic === id} onClick={() => setTopic(id)}>
              <span style={{ width: 20, height: 20, borderRadius: 10, flex: 'none', ...(topic === id ? { background: 'var(--ink)', border: '5px solid var(--butter)' } : { border: '1.5px solid var(--line-2)' }) }} />
              {label}
            </button>
          ))}
        </div>
      </div>
      {order && topic !== 'other' && <div className="card small">Приложим заказ {order}</div>}
      <textarea className="input" aria-label="Сообщение" placeholder="Напиши, чем помочь" value={text} maxLength={2000} onChange={(e) => setText(e.target.value)} />
      {topic === 'quality' && <PhotoPicker value={photo} onChange={setPhoto} />}
      <ErrorNote error={error} />
      {sent && (
        <div className="status">
          <Icon name="check" size={20} width={2.6} />
          {onSite ? 'Отправили флористу. Ответ придёт на почту, обычно в течение 15 минут, с 8:00 до 22:00' : 'Отправили. Твоё сообщение уже в чате с ботом, туда придёт ответ флориста'}
        </div>
      )}
      <div className="bottom">
        {sent ? (
          <button type="button" className="btn" onClick={() => (inTelegram ? closeApp() : back())}>
            {onSite ? 'Готово' : 'Перейти в чат'}
          </button>
        ) : (
        <button
          type="button"
          className="btn"
          disabled={(text.trim().length < 2 && !(topic === 'quality' && photo)) || sent}
          onClick={async () => {
            try {
              await api.support({ topic, text, orderId: topic !== 'other' ? order : undefined, photo: topic === 'quality' ? photo ?? undefined : undefined });
              track('support_sent', { topic, with_photo: Boolean(topic === 'quality' && photo), len: text.trim().length });
              setSent(true);
            } catch (e: any) {
              setError(e.message);
            }
          }}
        >
          Отправить
        </button>
        )}
      </div>
    </main>
  );
}

export function Docs() {
  const docs = [
    ['offer', 'Публичная оферта'],
    ['delivery', 'Доставка, замена и возврат'],
    ['privacy', 'Политика обработки персональных данных'],
    ['consent', 'Согласие на обработку данных'],
    ['ads', 'Согласие на рассылку'],
  ];
  return (
    <main className="screen">
      <TitleTop title="Документы и контакты" />
      <div className="list" data-noev>
        {docs.map(([id, t]) => (
          <a key={id} href={`/docs/${id}.html`} target="_blank" rel="noopener">
            <span style={{ flex: 1 }}>{t}</span>
            <Icon name="next" size={18} />
          </a>
        ))}
      </div>
      <div className="card stack s6">
        <span className="label">Продавец</span>
        <span className="small">ИП Лосева Екатерина Александровна</span>
        <span className="small">ИНН 504711870940, ОГРНИП 326508100214812</span>
        <span className="small">Почта: order@vydykhayflowers.ru</span>
      </div>
    </main>
  );
}
